import sum from 'lodash.sum'
import pick from 'lodash.pick'

function getProgressBarPoints(
  counts: Record<string, unknown>
): ProgressBarPoints {
  const completed = sum(Object.values(pick(counts, ['approved', 'completed'])))
  const pending = sum(Object.values(pick(counts, ['finished'])))
  const newInProgress = sum(
    Object.values(
      pick(counts, [
        'ongoing',
        'passed',
        'request',
        'rework',
        'sent_to_rework',
        'in_progress',
        'new',
        'hold',
        'rework_request'
      ])
    )
  )
  const total = completed + pending + newInProgress
  return {
    completed: (completed / total) * 100,
    pending: (pending / total) * 100,
    new: (newInProgress / total) * 100,
    completedCount: completed,
    pendingCount: pending,
    newInProgressCount: newInProgress,
    total
  }
}

export default getProgressBarPoints
